import { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';

const formatKES = (amount) =>
    'KES ' + Number(amount || 0).toLocaleString('en-KE', { minimumFractionDigits: 2 });

export default function BoughtTogetherSection({ items, onAddToCart, title = 'Frequently Bought Together' }) {
    const [adding, setAdding] = useState({});
    const [added, setAdded] = useState({});

    if (!items || items.length === 0) return null;

    const handleAdd = async (item) => {
        if (adding[item.variantId] || added[item.variantId]) return;
        setAdding(prev => ({ ...prev, [item.variantId]: true }));
        try {
            await onAddToCart(item.variantId, 1);
            setAdded(prev => ({ ...prev, [item.variantId]: true }));
        } finally {
            setAdding(prev => ({ ...prev, [item.variantId]: false }));
        }
    };

    return (
        <div className="bg-card rounded-xl border border-border p-4">
            <div className="flex items-center gap-2 mb-3">
                <i className="ri-shopping-bag-3-line text-primary text-lg"></i>
                <h3 className="font-semibold text-foreground text-sm">{title}</h3>
            </div>

            <div className="space-y-2">
                {items.map((item) => {
                    const imgSrc = item.image
                        ? (item.image.startsWith('http') ? item.image : `${API_URL}/${item.image}`)
                        : null;
                    const isAdded = added[item.variantId];
                    const isAdding = adding[item.variantId];

                    return (
                        <div
                            key={item.variantId}
                            className="flex items-center gap-3 p-2.5 rounded-lg border border-border hover:border-primary/30 transition-colors"
                        >
                            <div className="w-10 h-10 bg-muted rounded flex-shrink-0 overflow-hidden">
                                {imgSrc ? (
                                    <img src={imgSrc} alt={item.name} className="w-full h-full object-contain p-0.5" />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center">
                                        <i className="ri-image-line text-muted-foreground/40"></i>
                                    </div>
                                )}
                            </div>

                            <div className="flex-1 min-w-0">
                                <Link
                                    to={`/product/${item.slug}`}
                                    className="text-xs font-semibold text-foreground hover:text-primary transition-colors line-clamp-1"
                                >
                                    {item.name}
                                </Link>
                                <p className="text-xs font-bold text-primary mt-0.5">{formatKES(item.price)}</p>
                            </div>

                            <button
                                onClick={() => handleAdd(item)}
                                disabled={isAdding || isAdded}
                                className={`flex-shrink-0 px-2.5 py-1 rounded-md text-xs font-semibold transition-all ${
                                    isAdded
                                        ? 'bg-green-100 text-green-700 cursor-default'
                                        : 'bg-primary text-white hover:brightness-110 disabled:opacity-50'
                                }`}
                            >
                                {isAdding ? (
                                    <span className="w-3 h-3 border-2 border-white/40 border-t-white rounded-full animate-spin inline-block"></span>
                                ) : isAdded ? (
                                    <i className="ri-check-line"></i>
                                ) : (
                                    <i className="ri-add-line"></i>
                                )}
                            </button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
